const SALT = 'haebom.'

function decode(enc: unknown): string | null {
  if (typeof enc !== 'string' || enc.length === 0) return null

  try {
    const decoded = atob(enc)
    if (!decoded.startsWith(SALT)) return null
    const key = decoded.slice(SALT.length)
    return key.length > 0 ? key : null
  } catch {
    // base64 가 아니면 atob 이 던진다 — 키가 없는 것과 같이 다룬다.
    return null
  }
}

export function readKakaoRestKey(): string | null {
  return decode(import.meta.env.VITE_KAKAO_REST_KEY_ENC)
}

export function readKakaoJsKey(): string | null {
  return decode(import.meta.env.VITE_KAKAO_JS_KEY_ENC)
}
